/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCurveRegistry extends Contract<ITestCurveRegistry> {
  get_coins: Call<(_pool: AddressLike) => [string, string, string, string, string, string, string, string], ITestCurveRegistry>
  'get_coins(address)': Call<(_pool: AddressLike) => [string, string, string, string, string, string, string, string], ITestCurveRegistry>
  get_lp_token: Call<(_pool: AddressLike) => string, ITestCurveRegistry>
  'get_lp_token(address)': Call<(_pool: AddressLike) => string, ITestCurveRegistry>
}

let ITestCurveRegistryBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCurveRegistryBytecode = '0x';
}

// prettier-ignore
export const ITestCurveRegistry = contract<ITestCurveRegistry>(ITestCurveRegistryBytecode)`
  function get_coins(address _pool) view returns (address[8] coins_)
  function get_lp_token(address _pool) view returns (address token_)
`;